module.exports = __webpack_public_path__ + "static/media/12.6cf2cad4.JPG";